export default __webpack_public_path__ + "static/media/ic_telegram.2ef622e5.svg";